export function padStart(value: string, length: number): string {
	var zeroes = '0'.repeat(length);
	return zeroes + value;
}
export const getLast4Number = (value: string) => {
	const result = value.match(/\D+|\d+/g);
	if (result === null) {
		return '';
	}
	if (result.length === 3) {
		return result![result.length - 1].slice(-4);
	}
	return result![0].slice(-4);
};

export const isDate = (date: string) => {
	return (
		(new Date(date) as any) !== 'Invalid Date' && !isNaN(new Date(date) as any)
	);
};
